import {BasePage, page, playVideo} from "./BasePage";
import {MintBlock} from "../components/MintBlock";
import {FramedVideo} from "../components/FramedVideo";
import {A1} from "../../assets/A1/ani";
import {A2} from "../../assets/A2/ani";
import {A3} from "../../assets/A3/ani";
import {A4} from "../../assets/A4/ani";
import {main} from "../../assets/main/ani";

@page("Title")
export class Title extends BasePage {

	protected get data(): any {
		return {
			content: `PokerDAO is creating a modern Texas Hold'em poker club. A community of thousands of enthusiasts worldwide have come together to create and reimagine one of the world's greatest Texas Hold'em poker clubs`
		};
	}

	protected webContent() {
		// 在这里完善内容
		return <div>
			<div className="main-card">
				{/*<img id="card" src={require("../../assets/main.gif")}/>*/}
				<FramedVideo id="card" root={main} spacing={2}/>
				{/*<video id="card" loop*/}
				{/*			 controls controlsList='nofullscreen nodownload noremote footbar'*/}
				{/*			 onLoadedMetadata={playVideo} onClick={playVideo}*/}
				{/*			 src={require("../../assets/main.mp4")}/>*/}
			</div>
			<div className="left">
				<div className="shine blue-shine"/>
				<div className="text">
					<div className="title">POKERDAO</div>
					<div className="content">{this.data.content}</div>
					<MintBlock/>
					{/*<div className="discord button">*/}
					{/*	<div className="label">JOIN THE DISCORD</div>*/}
					{/*	<div className="effect"/>*/}
					{/*	<img src={require("../../assets/button-frame1-small.png")}/>*/}
					{/*</div>*/}
				</div>
			</div>
		</div>
	}

	protected mobileContent(): JSX.Element {
		return <div>
			{/*<div className="shine blue-shine"/>*/}
			<div className="text">
				<div className="title">POKERDAO</div>
				<div className="content">{this.data.content}</div>
				<MintBlock connect={true}/>
				{/*<div className="discord button">*/}
				{/*	<div className="label">MINT NOW</div>*/}
				{/*	<div className="effect"/>*/}
				{/*	<img src={require("../../assets/button-frame1-small.png")}/>*/}
				{/*</div>*/}
			</div>
			<div className="main-card">
				{/*<img id="card" src={require("../../assets/main.gif")}/>*/}
				<FramedVideo id="card" root={main} spacing={2}/>
				{/*<video id="card" loop*/}
				{/*			 controls controlsList='nofullscreen nodownload noremote footbar'*/}
				{/*			 onLoadedMetadata={playVideo} onClick={playVideo}*/}
				{/*			 src={require("../../assets/main.mp4")}/>*/}
			</div>
		</div>
	}
}
